/* eslint-disable prefer-arrow-callback */
/* eslint-disable jquery/no-attr */
/* eslint-disable object-shorthand */
/* eslint-disable jquery/no-ajax */
/* eslint-disable jquery/no-find */
/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */
/* eslint-disable jquery/no-class */
/* eslint-disable jquery/no-is */
/* eslint-disable jquery/no-parent */
/* eslint-disable jquery/no-closest */
/* eslint-disable prefer-template */
/* eslint-disable jquery/no-show */
/* eslint-disable jquery/no-hide */
/* eslint-disable jquery/no-html */
/* eslint-disable jquery/no-data */
/* eslint-disable jquery/no-sizzle */
import base from '~base';

import $ from 'jquery';
import processInclude from '../util';
import scrollTo from '../util/scrollTo';
import { onEvent } from '../util/domutils'; // eslint-disable-line import/named
import { loadContent, fetchOptionsGet } from '../util/fetchutils'; // eslint-disable-line import/named
import Glide from '@glidejs/glide';

export const CONSTANTS = $.extend(true, {}, {
  MODIFY_OVERLAY_DURATION: 1800,
  MODIFY_TYPES: {
    REMOVE: 'REMOVE',
  },
}, base.CONSTANTS || {});

const CLASSES = $.extend(true, {}, {
  MODIFIERS: {
    [CONSTANTS.MODIFY_TYPES.REMOVE]: 'product-card__modifier--remove',
  },
  MODIFY_OVERLAYS: {
    ACTIVE: 'product-card__modify-overlay--active',
    [CONSTANTS.MODIFY_TYPES.REMOVE]: 'product-card__modify-overlay--remove',
  },
}, base.CLASSES || {});

const SELECTORS = $.extend(true, {}, {
  HEADER: '.cart-header',
  PRODUCT: '.product-card__wrapper',
  MODIFIERS: '.product-card__modifier',
  MODIFY_OVERLAYS: {
    GENERIC: '.product-card__modify-overlay',
    ACTIVE: `.${CLASSES.MODIFY_OVERLAYS.ACTIVE}`,
    [CONSTANTS.MODIFY_TYPES.REMOVE]: `.${CLASSES.MODIFY_OVERLAYS.REMOVE}`,
    UNDO_LINK: '.product-card__modify-overlay__undo__link',
  },
  REMOVE_CONFIRM: '.cart-delete-confirmation-btn',
  FREE_SHIPPING_DISCOUNT: '.free-shipping-discount',
  FREE_SHIPPING_DISCOUNT_MESSAGE: '.free-shipping-discount-message',
}, base.SELECTORS || {});

export const EVENTS = base.EVENTS || {};

const handleModification = (type, trigger, productCard) => {
  document.dispatchEvent(new CustomEvent(EVENTS.ITEM_MODIFICATION, {
    detail: {
      type,
      trigger,
      productCard,
    },
  }));

  if (type === CONSTANTS.MODIFY_TYPES.REMOVE) {
    const removeConfirmBtn = document.querySelector(SELECTORS.REMOVE_CONFIRM);

    if (removeConfirmBtn) {
      removeConfirmBtn.click();
    }
  }
};

/**
 * Handles free shipping discount message change
 */
const changeFreeShippingDiscountMessage = (discount) => {
  const freeShippingDiscount = document.querySelector(SELECTORS.FREE_SHIPPING_DISCOUNT);
  const freeShippingDiscountMessage = document.querySelector(SELECTORS.FREE_SHIPPING_DISCOUNT_MESSAGE);

  if (discount) {
    freeShippingDiscountMessage.classList.remove('d-none');
    freeShippingDiscount.innerHTML = discount;
  } else {
    freeShippingDiscountMessage.classList.add('d-none');
  }
};

/**
* Updates the availability of a product line item
*/
const updateAvailability = (data, uuid) => {
  let lineItem;
  let messages = '';

  for (let i = 0; i < data.items.length; i++) {
    if (data.items[i].UUID === uuid) {
      lineItem = data.items[i];
      break;
    }
  }

  $(`.availability-${lineItem.UUID}`).empty();

  if (lineItem.availability) {
    if (lineItem.lowStock && lineItem.availableStockQuantity && lineItem.lowStockMessage) {
      messages = `<p style="color:${lineItem.pdpLowStockHexColorCode}"
      class="line-item-attributes">${lineItem.lowStockMessage}</p>`;
    } else if (lineItem.availability.messages) {
      lineItem.availability.messages.forEach((message) => {
        messages += `<p class="line-item-attributes">${message}</p>`;
      });
    }

    if (lineItem.availability.inStockDate) {
      messages += `<p class="line-item-attributes line-item-instock-date">${lineItem.availability.inStockDate}</p>`;
    }
  }

  // eslint-disable-next-line jquery/no-html
  $(`.availability-${lineItem.UUID}`).html(messages);
};

/**
 * Updates free shipping discount on line item quantity change
 */
const updateFreeShippingDiscount = () => {
  onEvent(document, 'change', '#lineItemQuantity', () => {
    $(document).on('ajaxComplete', (e, xhr) => {
      if (xhr.responseJSON) {
        changeFreeShippingDiscountMessage(xhr.responseJSON.freeSheepingDiscount);
      }
    });
  });

  onEvent(document, 'click', '.promo-code-btn', () => {
    $(document).on('ajaxComplete', (e, xhr) => {
      if (xhr.responseJSON) {
        changeFreeShippingDiscountMessage(xhr.responseJSON.freeSheepingDiscount);
      }
    });
  });

  onEvent(document, 'click', '.delete-coupon-confirmation-btn', () => {
    $(document).on('ajaxComplete', (e, xhr) => {
      if (xhr.responseJSON) {
        changeFreeShippingDiscountMessage(xhr.responseJSON.freeSheepingDiscount);
      }
    });
  });
};

const updatePurchaseAmount = (selector, amount) => {
  const dataVal = selector === '.paypal-cart-osm .paypal' ? 'data-pp-amount' : 'data-purchase-amount';
  const elements = document.querySelectorAll(selector);
  if (elements.length > 0) {
    elements.forEach(element => element.setAttribute(dataVal, amount));
    // eslint-disable-next-line no-undef
    if (typeof PayPalSDK !== 'undefined') {
      // eslint-disable-next-line no-undef
      PayPalSDK.Messages().render();
    }
  }
};

const updateCartItems = () => {
  const initUpdateMiniCartEvent = (event) => {
    // eslint-disable-next-line prefer-destructuring
    const uuid = event.target.dataset.uuid;

    const selectElement = event.target;
    const selectedOption = selectElement.options && selectElement.selectedIndex && selectElement.options[selectElement.selectedIndex];

    if (!selectElement.classList.contains('js-nominated-day-cart')) {
      document.querySelectorAll('.js-nominated-day-radio').forEach((el) => {
        el.checked = false;
      });
    }

    $(document).one('ajaxComplete', (e, xhr) => {
      if (xhr.responseJSON) {
        const cart = xhr.responseJSON.basket || xhr.responseJSON;
        const quantity = cart && cart.numItems;
        const grandTotalCart = cart.totals.grandTotal.slice(1) * 100;
        const grandTotal = cart.totals.grandTotal.slice(1);

        if ($('.klarna-cart-osm').length > 0) {
          const KlarnaThresholdValue = Math.round($('.klarna-cart-osm').data('threshold'));
          const isBelowThreshold = KlarnaThresholdValue && Math.round(grandTotal) >= KlarnaThresholdValue;

          $('.klarna-cart-osm.mobile').toggleClass('d-none', !isBelowThreshold);
          $('.klarna-cart-osm.desktop').toggleClass('d-md-block', isBelowThreshold);
        }

        // Update Klarna and PayPal purchase amounts
        updatePurchaseAmount('.klarna-cart-osm .credit-promotion', grandTotalCart);
        updatePurchaseAmount('.paypal-cart-osm .paypal', grandTotal);

        if (!quantity || quantity === 0) {
          window.location.reload();
        } else {
          $(SELECTORS.PARENT).trigger('count:update', xhr.responseJSON); // eslint-disable-line jquery/no-trigger
        }
        if (uuid) {
          updateAvailability(xhr.responseJSON, uuid);
        }
        if (xhr.responseJSON.basket) {
          changeFreeShippingDiscountMessage(xhr.responseJSON.basket.freeSheepingDiscount);
        } else {
          changeFreeShippingDiscountMessage(xhr.responseJSON.freeSheepingDiscount);
        }

        const shippingMethodsElement = document.querySelector('.js-onestock-cart-shipping-methods');

        if (shippingMethodsElement && xhr.responseJSON.renderTemplate) {
          const $parsedResponse = $(xhr.responseJSON.renderTemplate);
          const $newShippingSelect = $parsedResponse.find('#shippingMethods');
          const $existingShippingSelect = $('#shippingMethods');

          if ($newShippingSelect.length && $existingShippingSelect.length) {
            $existingShippingSelect.empty();
            $existingShippingSelect.html($newShippingSelect.html());
          }

          if (selectedOption && selectedOption.classList.contains('js-nominated-day-cart-option') && document.querySelectorAll('.js-nominated-modal-btn').length) {
            const $nominatedDayModalMethods = $parsedResponse.find('.js-nominated-day-section');
            if ($nominatedDayModalMethods && $('.js-nominated-day-section').length) {
              $('.js-nominated-day-section').empty().html($nominatedDayModalMethods.html());
            }
            document.querySelector('.js-nominated-modal-btn').click();
          }
        }

        const nominatedModal = document.querySelector('.nominated-day-flyout-modal');
        if (nominatedModal && nominatedModal.classList.contains('show') && nominatedModal.querySelectorAll('input:checked').length) {
          const nominatedModalCloseBtn = document.querySelector('.js-nominated-day-modal-close-btn');
          if (nominatedModalCloseBtn) { nominatedModalCloseBtn.click(); }
        }
      }
    });
  };

  // Nominated Day Shipping Method Switcher
  const updateNominatedDayMethod = (e) => {
    e.preventDefault();
    const element = e.delegateTarget;
    const shippingId = element && element.getAttribute('data-shipping-id');
    const nominatedDayEle = document.querySelector(`.js-nominated-day-cart[data-shipping-id="${shippingId}"]`);

    if (element.querySelector('input') && nominatedDayEle) {
      element.querySelector('input').checked = 'checked';
      nominatedDayEle.selected = true;
      $('.js-nominated-day-section').spinner().start();
      nominatedDayEle.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  onEvent(document, 'change', '.quantity-form > .quantity', initUpdateMiniCartEvent);
  onEvent(document, 'click', '.cart-delete-confirmation-btn', initUpdateMiniCartEvent);
  onEvent(document, 'change', '#shippingMethods', initUpdateMiniCartEvent);
  onEvent(document, 'click', '.js-shipping-method-dropdown-item', updateNominatedDayMethod);
  onEvent(document, 'change', '#nominatedShippingMethods', initUpdateMiniCartEvent);
};

const handlePreItemsReload = () => {
  document.dispatchEvent(new CustomEvent(EVENTS.BEFORE_ITEMS_RELOAD));
};

// Handles show and hide conditions for apple pay express checkout elements.
const applePayExpressCheckout = () => {
  const element = document.querySelector('.cart-optin__submit-wrapper');
  let displayNewsletterOptin;
  if (element !== null) {
    displayNewsletterOptin = element.dataset.displayNewsletterOptin;
  }
  const appleExpressCheckout = document.querySelectorAll('.apple-pay-express-checkout');
  const shippingMethods = document.getElementById('shippingMethods');
  const selectedShippingMethod = shippingMethods.options[shippingMethods.selectedIndex];
  const dataInstore = selectedShippingMethod.getAttribute('data-instore');

  // Hides apple pay for click and collect on cart page.
  for (let i = 0; i < appleExpressCheckout.length; i++) {
    if (dataInstore && dataInstore === 'true') {
      appleExpressCheckout[i].classList.add('is-click-and-collect', 'express-checkout-container');
    } else {
      appleExpressCheckout[i].classList.remove('is-click-and-collect');
      if (displayNewsletterOptin === 'false') {
        appleExpressCheckout[i].classList.add('disable-consent-checkbox', 'cart-express');
        appleExpressCheckout[i].classList.remove('express-checkout-container');
      } else {
        appleExpressCheckout[i].classList.remove('disable-consent-checkbox', 'cart-express');
      }
    }
  }
};

// document.getElementById('shippingMethods').addEventListener('change', applePayExpressCheckout);
$(document).on('change', '#shippingMethods', () => {
  applePayExpressCheckout();
});
// Sends Cart opt in consent events to Controller.
const handleCheckboxChangeCartConsents = () => {
  const formData = {};
  let actionUrl;

  const addToEmailList = document.querySelector('.cart_addtoemaillist');
  const addtosmslist = document.querySelector('.cart_addtosmslist');
  const addtopostlist = document.querySelector('.cart_addtopostlist');
  const addToThirdPartyOptIn = document.querySelector('.cart_addtothirdpartylist');
  const consentActionUrl = document.getElementById('consentActionUrl');

  if (addToEmailList) {
    formData.emailOptIn = addToEmailList.checked;
  }
  if (addtosmslist) {
    formData.phoneOptIn = addtosmslist.checked;
  }
  if (addtopostlist) {
    formData.postOptIn = addtopostlist.checked;
  }
  if (addToThirdPartyOptIn) {
    formData.thirdPartyOptIn = addToThirdPartyOptIn.checked;
  }
  if (consentActionUrl) {
    actionUrl = consentActionUrl.href;
  }

  // eslint-disable-next-line jquery/no-ajax
  $.ajax({
    type: 'post',
    url: actionUrl,
    data: formData,
    success() {},
    error() { },
  });
};

$(document).on('change', '.cart_addtoemaillist, .cart_addtosmslist, .cart_addtopostlist, .cart_addtothirdpartylist', handleCheckboxChangeCartConsents);

// Shows apple pay cart consents dropdown
const showApplePayCartConsents = () => {
  const consents = document.querySelectorAll('.cart-optin__submit');
  consents.forEach(consent => consent.classList.toggle('active'));
};

$(document).on('click', '.consents-dropdown', showApplePayCartConsents);

const updateOtherConsents = function (inputs, target) {
  const ischecked = target.checked;
  for (let i = 0; i < inputs.length; i++) {
    const inputElement = inputs[i];
    inputElement.checked = ischecked;
  }
};

// Sync consent checkboxes on cart page.
const syncConsents = () => {
  const consentGroups = [
    document.querySelectorAll('.cart_addtoemaillist'),
    document.querySelectorAll('.cart_addtosmslist'),
    document.querySelectorAll('.cart_addtopostlist'),
    document.querySelectorAll('.cart_addtothirdpartylist'),
  ];

  for (let i = 0; i < consentGroups.length; i++) {
    const inputs = consentGroups[i];
    for (let j = 0; j < inputs.length; j++) {
      inputs[j].addEventListener('change', (event) => {
        updateOtherConsents(inputs, event.target);
      });
    }
  }
};

// Show apple pay express checkout only for apple pay enabled devices
const showApplePayExpressCheckout = () => {
  const appleExpressCheckout = document.querySelectorAll('.apple-pay-express-checkout');
  if (appleExpressCheckout) {
    for (let i = 0; i < appleExpressCheckout.length; i++) {
      appleExpressCheckout[i].style.display = 'block';
    }
  }
};

const handleItemsReload = () => {
  document.dispatchEvent(new CustomEvent(EVENTS.ITEMS_RELOAD));
  document.dispatchEvent(new CustomEvent('lazy-load-force-update'));

  if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
    showApplePayExpressCheckout();
    syncConsents();
    applePayExpressCheckout();
  }
};

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
  $('.number-of-items').empty().append(data.resources.numberOfItems);
  $('.shipping-cost').empty().append(data.totals.totalShippingCost);
  $('.tax-total').empty().append(data.totals.totalTax);
  $('.grand-total').empty().append(data.totals.grandTotal);
  $('.sub-total').empty().append(data.totals.subTotal);
  $('.minicart-quantity').empty().append(data.numItems);

  if (data.totals.orderLevelDiscountTotal.value > 0) {
    $('.order-discount').removeClass('hide-order-discount');
    $('.order-discount-total').empty().append('- ' + data.totals.orderLevelDiscountTotal.formatted);
  } else {
    $('.order-discount').addClass('hide-order-discount');
  }

  if (data.totals.shippingLevelDiscountTotal.value > 0) {
    $('.shipping-discount').removeClass('hide-shipping-discount');
    $('.shipping-discount-total').empty().append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
  } else {
    $('.shipping-discount').addClass('hide-shipping-discount');
  }

  data.items.forEach(function (item) {
    $('.item-' + item.UUID).empty().append(item.renderedPromotions);
    $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
  });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
  const errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
    + 'fade show" role="alert">'
    + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
    + '<span aria-hidden="true">&times;</span>'
    + '</button>' + message + '</div>';

  $('.cart-error').append(errorHtml);
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
  if (data.valid.error) {
    if (data.valid.message) {
      const errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
        + 'fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button>' + data.valid.message + '</div>';

      $('.cart-error').append(errorHtml);
    } else {
      $('.cart').empty().append('<div class="row"> '
        + '<div class="col-12 text-center"> '
        + '<h1>' + data.resources.emptyCartMsg + '</h1> '
        + '</div> '
        + '</div>');
      $('.number-of-items').empty().append(data.resources.numberOfItems);
      $('.minicart-quantity').empty().append(data.numItems);
      $('.minicart .popover').empty();
      $('.minicart .popover').removeClass('show');
    }

    $('.checkout-btn').addClass('disabled');
  } else {
    $('.checkout-btn').removeClass('disabled');
  }
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
  let html = '';
  $('.approaching-discounts').empty();
  if (approachingDiscounts.length > 0) {
    approachingDiscounts.forEach(function (item) {
      html += '<div class="single-approaching-discount text-center">' + item.discountMsg + '</div>';
    });
  }
  $('.approaching-discounts').append(html);
}

export const init = () => {
  processInclude(base);

  updateCartItems();

  updateFreeShippingDiscount();

  const cartWishlistFallbackCallout = document.querySelector('#cart-wishlist-fallback span');
  const cartWishlistFallbackHeading = document.querySelector('#wishlist-fallback-heading span');
  if (cartWishlistFallbackCallout !== null) {
    cartWishlistFallbackHeading.innerHTML = cartWishlistFallbackCallout.innerHTML;
  }
  const cartWishlistFallbackMobileCallout = document.querySelector('#cart-wishlist-fallback-mobile span');
  const cartWishlistFallbackMobileHeading = document.querySelector('#wishlist-fallback-mobile-heading span');
  if (cartWishlistFallbackMobileCallout !== null) {
    cartWishlistFallbackMobileHeading.innerHTML = cartWishlistFallbackMobileCallout.innerHTML;
  }
  if (cartWishlistFallbackMobileHeading) {
    cartWishlistFallbackMobileHeading.classList.remove('d-none');
  }
  if (cartWishlistFallbackHeading) {
    cartWishlistFallbackHeading.classList.remove('d-none');
  }
  onEvent(document, 'change', '.size-form > .size', async (event) => {
    handlePreItemsReload();

    const inputData = event.target.dataset;
    const urlParams = {
      uuid: inputData.uuid,
      size: event.target.value,
      quantity: inputData.quantity,
    };

    const { content } = await loadContent(event.target, null, urlParams);

    document.querySelector('.cart-container').outerHTML = content;
    // eslint-disable-next-line no-undef
    if (typeof PayPalSDK !== 'undefined') {
      // eslint-disable-next-line no-undef
      PayPalSDK.Messages().render();
    }

    const updateContainer = document.querySelector('.cart-container');

    // eslint-disable-next-line jquery/no-trigger
    $('.minicart').trigger('count:update', {
      numItems: updateContainer.dataset.count,
      totals: {
        grandTotal: updateContainer.dataset.total,
      },
    });

    handleItemsReload();
  });

  onEvent(document, 'click', SELECTORS.MODIFIERS, (e) => {
    e.preventDefault();

    const modifier = e.delegateTarget;
    const modifierClasses = CLASSES.MODIFIERS;
    const modifyType = Object.keys(modifierClasses).find(type => modifier.classList.contains(modifierClasses[type]));
    const productCard = modifier.closest(SELECTORS.PRODUCT);

    if (modifyType) {
      const modifyHandler = handleModification.bind(null, modifyType, modifier, productCard);
      const modifyOverlay = productCard.querySelector(SELECTORS.MODIFY_OVERLAYS[modifyType]);

      if (modifyOverlay) {
        modifyOverlay.classList.add(CLASSES.MODIFY_OVERLAYS.ACTIVE);
        modifyOverlay.dataset.timeout = setTimeout(modifyHandler, CONSTANTS.MODIFY_OVERLAY_DURATION);
      }
    }
  });

  onEvent(document, 'click', SELECTORS.MODIFY_OVERLAYS.UNDO_LINK, (e) => {
    const overlay = e.delegateTarget.closest(SELECTORS.MODIFY_OVERLAYS.GENERIC);

    if (overlay && overlay.dataset.timeout) {
      clearTimeout(overlay.dataset.timeout);
      overlay.classList.remove(CLASSES.MODIFY_OVERLAYS.ACTIVE);
    }
  });

  window.onbeforeunload = (e) => {
    const activeOverlay = document.querySelector(SELECTORS.MODIFY_OVERLAYS.ACTIVE);

    if (activeOverlay) {
      e.returnValue = '';
      e.preventDefault();

      return '';
    }

    return undefined;
  };

  $(document).on('product:afterAddToCart', async (e, data) => {
    if (!data.error) {
      const url = new URL(window.location);
      url.searchParams.append('skipDecorator', true);

      const response = await fetch(url, fetchOptionsGet());
      const content = await response.text();

      handlePreItemsReload();

      document.querySelector('.cart-container').outerHTML = content;

      const $shippingMethodsElement = $('.onestock-cart-shipping-methods');
      if ($shippingMethodsElement && data.renderTemplate) {
        const $parsedResponse = $(data.renderTemplate);
        const $newShippingSelect = $parsedResponse.find('#shippingMethods');
        const $existingShippingSelect = $('#shippingMethods');

        if ($newShippingSelect.length && $existingShippingSelect.length) {
          $existingShippingSelect.empty();
          $existingShippingSelect.html($newShippingSelect.html());
        }
        // eslint-disable-next-line jquery/no-filter
        const $newCustomShippingMethodEle = $parsedResponse
          .filter('.onestock-cart-shipping-methods')
          .add($parsedResponse.find('.onestock-cart-shipping-methods'));

        if ($newCustomShippingMethodEle.length && $existingShippingSelect.length) {
          $shippingMethodsElement.replaceWith($newCustomShippingMethodEle);
        }
      }
      scrollTo(0);

      handleItemsReload();
    }
  });

  $(document).on('change', '.shippingMethods', function () {
    const url = $(this).attr('data-actionUrl');
    const urlParams = {
      methodID: $(this).find(':selected').attr('data-shipping-id'),
    };
    // url = appendToUrl(url, urlParams);

    $('.totals').spinner().start();
    $.ajax({
      url: url,
      type: 'post',
      dataType: 'json',
      data: urlParams,
      success: function (data) {
        if (data.error) {
          window.location.href = data.redirectUrl;
        } else {
          $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
          updateCartTotals(data);
          updateApproachingDiscounts(data.approachingDiscounts);
          validateBasket(data);
        }
        $.spinner().stop();
      },
      error: function (err) {
        if (err.redirectUrl) {
          window.location.href = err.redirectUrl;
        } else {
          createErrorNotification(err.responseJSON.errorMessage);
          $.spinner().stop();
        }
      },
    });
  });

  const GLIDE_SELECTORS = {
    NAVIGATORS: {
      ARROWS: '.glide__arrows',
    },
  };

  const CustomLength = function (glide, Components, Events) {
    const addToBagCarouselEvents = {
      handleSlider() {
        if (Components.Sizes.length <= glide.settings.perView) {
          glide.disable();
          Components.Html.root.querySelector(GLIDE_SELECTORS.NAVIGATORS.ARROWS).classList.add('d-none');
        } else {
          glide.enable();
          Components.Html.root.querySelector(GLIDE_SELECTORS.NAVIGATORS.ARROWS).classList.remove('d-none');
        }
      },
      mount() {
        this.handleSlider();
      },
    };
    Events.on('resize', () => {
      addToBagCarouselEvents.handleSlider();
    });
    return addToBagCarouselEvents;
  };

  const cartCarouselInit = function () {
    let slidesCount = 3;
    if ($('.cartPageAddOnsEnable').length && parseInt($('.cartPageAddOnsEnable').data('slides-per-view'), 10) > 0) {
      slidesCount = parseInt($('.cartPageAddOnsEnable').data('slides-per-view'), 10);
    }
    if ($('.cart-product-lineItem-recommendations').length) {
      new Glide('.cart-product-lineItem-recommendations', {
        type: 'slider',
        perView: slidesCount,
        gap: 10,
        rewind: false,
        bound: true,
        peek: { before: 0, after: 0 },
        breakpoints: {
          1440: {
            perView: slidesCount,
            peek: { before: 0, after: 0 },
          },
          992: {
            perView: 3,
            peek: { before: 0, after: 0 },
          },
          540: {
            perView: 1,
            peek: { before: 0, after: 150 },
          },
        },
      }).mount({ CustomLength });
    }
  };

  const cartBottomCarouselInit = function () {
    if ($('.cart-bottom-recommendations').length) {
      const cartRecommendations = document.querySelectorAll('.cart-bottom-recommendations');
      for (let i = 0; i < cartRecommendations.length; i++) {
        new Glide(cartRecommendations[i], {
          type: 'slider',
          perView: 2,
          rewind: false,
          bound: true,
          gap: 16,
          peek: { before: 0, after: 0 },
          breakpoints: {
            768: {
              perView: 1,
            },
          },
        }).mount({ CustomLength });
      }
    }
  };

  $(document).ready(() => {
    if ($('.productLineItemRecomBtn').length) {
      $('.productLineItemRecomBtn:first').click();
    }
    cartBottomCarouselInit();
  });

  document.addEventListener(EVENTS.ITEMS_RELOAD, () => {
    if ($('.productLineItemRecomBtn').length) {
      $('.productLineItemRecomBtn:first').click();
    }
    cartBottomCarouselInit();
  });

  document.addEventListener(EVENTS.ITEM_MODIFICATION, () => {
    setTimeout(() => {
      if ($('.productLineItemRecomContainer').children().length === 0
      && $('.productLineItemRecomBtn').length) {
        $('.productLineItemRecomBtn:first').click();
      }
    }, CONSTANTS.MODIFY_OVERLAY_DURATION + 200);
  });

  $(document).on('click', '.productLineItemRecomContainer .add-to-cart', () => {
    $.spinner().start();
  });

  $(document).on('click', '.productLineItemRecomBtn', async function (e) {
    e.preventDefault();
    const url = $(this).data('action');
    const pid = $(this).data('pid');
    const uuid = $(this).data('uuid');

    if (!url || !pid) {
      return;
    }
    $.spinner().start();
    // eslint-disable-next-line jquery/no-ajax
    $.ajax({
      url,
      type: 'get',
      data: {
        pid,
      },
      success: (data) => {
        $('.productLineItemRecomContainer').html('');
        $(this).hide();
        $('.productLineItemRecomBtn').not(this).show();
        $('.productLineItemRecomContainer-' + uuid).html(data);
        cartCarouselInit();
        $('.cart-item').removeClass('cartItemActive');
        $('.cart-item').removeClass('cartItemActivePrev');
        const itemParent = $('.productLineItemRecomContainer-' + uuid).parent().closest('.cart-item');
        $(itemParent).addClass('cartItemActive');
        if ($('.cartItemActive') && $('.cartItemActive').prev()) {
          $('.cartItemActive').prev().addClass('cartItemActivePrev');
        }
        $.spinner().stop();
      },
      error() {
        $.spinner().stop();
      },
    });
  });

  $(document).on('click', '.cart-recommendation-close-btn', (e) => {
    e.preventDefault();
    $('.cart-item').removeClass('cartItemActive');
    $('.cart-item').removeClass('cartItemActivePrev');
    $('.productLineItemRecomContainer').html('');
    $('.productLineItemRecomBtn').show();
  });

  $(document).on('click', '.cart-recommendation-close-btn-bottom', (e) => {
    e.preventDefault();
    $('.cart-recommendations-bottom-row').remove();
  });

  document.addEventListener('cart:carousel-init', cartCarouselInit);
  document.addEventListener('cart-bottom:carousel-init', cartBottomCarouselInit);

  $(document).on('click', (e) => {
    if ($(e.target).closest('.js-shipping-method').length) {
      e.preventDefault();
      $('.js-shipping-method-dropdown').toggleClass('expand');
      return;
    }

    if (!$(e.target).closest('.js-shipping-method-dropdown').length) {
      $('.js-shipping-method-dropdown').removeClass('expand');
    }
  });
};

$(document).ready(() => {
  if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
    showApplePayExpressCheckout();
    syncConsents();
    applePayExpressCheckout();
    handleCheckboxChangeCartConsents();
  }
});
